import { createSlice } from "@reduxjs/toolkit";
import lang from "../../assets/lang/icons.json";

const initialState = {
  videoConferenceText: [
    {
      videoConferenceText: "",
    },
  ],

  videoConferenceColor: [
    {
      videoConferenceColor: "rgba(40,44,166,100)",
    },
  ],
  videoConferenceSize: [
    {
      videoConferenceSize: 1,
    },
  ],
  videoConferenceType: [
    {
      videoConferenceType: "",
    },
  ],
  videoConferenceLink: [
    {
      videoConferenceLink: "",
    },
  ],
};

export const videoConferenceSlice = createSlice({
  name: "videoConference",
  initialState,
  reducers: {
    videoConferenceText: (state, action) => {
      if (action.payload === "" && action.payload === null) {
        state.videoConferenceText = [];
        state.videoConferenceText = [
          ...state.videoConferenceText,
          initialState.videoConferenceText[0],
        ];
      } else {
        const videoConferenceText = action.payload;

        state.videoConferenceText = [];
        state.videoConferenceText = [
          ...state.videoConferenceText,
          { videoConferenceText },
        ];
      }
    },

    videoConferenceColor: (state, action) => {
      if (action.payload === "" && action.payload == null) {
        state.videoConferenceColor = [];
        state.videoConferenceColor = [
          ...state.videoConferenceColor,
          initialState.videoConferenceColor[0],
        ];
      } else {
        const videoConferenceColor = action.payload;

        state.videoConferenceColor = [];
        state.videoConferenceColor = [
          ...state.videoConferenceColor,
          { videoConferenceColor },
        ];
      }
    },

    videoConferenceSize: (state, action) => {
      if (action.payload === "" && action.payload == null) {
        state.videoConferenceSize = [];
        state.videoConferenceSize = [
          ...state.videoConferenceSize,
          initialState.videoConferenceSize[0],
        ];
      } else {
        const videoConferenceSize = action.payload;
        state.videoConferenceSize = [];
        state.videoConferenceSize = [
          ...state.videoConferenceSize,
          { videoConferenceSize },
        ];
      }
    },

    videoConferenceType: (state, action) => {
      if (action.payload === "" && action.payload == null) {
        state.videoConferenceType = [];
        state.videoConferenceType = [
          ...state.videoConferenceType,
          initialState.videoConferenceType[0],
        ];
      } else {
        const videoConferenceType = action.payload;
        state.videoConferenceType = [];
        state.videoConferenceType = [
          ...state.videoConferenceType,
          { videoConferenceType },
        ];
      }
    },

    videoConferenceLink: (state, action) => {
      if (action.payload === "" && action.payload == null) {
        state.videoConferenceLink = [];
        state.videoConferenceLink = [
          ...state.videoConferenceLink,
          initialState.videoConferenceLink[0],
        ];
      } else {
        const videoConferenceLink = action.payload;
        state.videoConferenceLink = [];
        state.videoConferenceLink = [
          ...state.videoConferenceLink,
          { videoConferenceLink },
        ];
      }
    },

    resetvideoConference: (state, action) => {
      if (action.payload === true) {
        state.videoConferenceText = [];
        state.videoConferenceText = [
          ...state.videoConferenceText,
          initialState.videoConferenceText[0],
        ];

        state.videoConferenceColor = [];
        state.videoConferenceColor = [
          ...state.videoConferenceColor,
          initialState.videoConferenceColor[0],
        ];

        state.videoConferenceSize = [];
        state.videoConferenceSize = [
          ...state.videoConferenceSize,
          initialState.videoConferenceSize[0],
        ];

        state.videoConferenceType = [];
        state.videoConferenceType = [
          ...state.videoConferenceType,
          initialState.videoConferenceType[0],
        ];

        state.videoConferenceLink = [];
        state.videoConferenceLink = [
          ...state.videoConferenceLink,
          initialState.videoConferenceLink[0],
        ];
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  videoConferenceText,
  videoConferenceColor,
  videoConferenceSize,
  videoConferenceType,
  videoConferenceLink,
  resetvideoConference,
} = videoConferenceSlice.actions;

export default videoConferenceSlice.reducer;
